module.exports = __webpack_public_path__ + "img/navigation.e46228dd.svg";